"use client";

import { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  IconButton,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Tooltip,
} from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEmployerSubscriptionasync,
  selectPagination,
  selectSubscription,
} from "../../Subscriptions/SubscriptionDetails/SubscriptionSlice";

const SubscriberList = () => {
  const dispatch = useDispatch();
  const subscribers = useSelector(selectSubscription);
  const pagination = useSelector(selectPagination);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedSubscriber, setSelectedSubscriber] = useState(null);
  // console.log("subscribers", subscribers)

  useEffect(() => {
    dispatch(fetchEmployerSubscriptionasync(1));
  }, [dispatch]);

  const handlePageChange = (page) => {
    dispatch(fetchEmployerSubscriptionasync(page));
  };

  const handleViewDetails = (subscriber) => {
    setSelectedSubscriber(subscriber);
    onOpen();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Get day, month and year
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    // Add ordinal suffix to day
    const ordinal = (day) => {
      if (day > 3 && day < 21) return day + "th";
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    };

    return `${ordinal(day)} ${month}, ${year}`;
  };

  return (
    <div
      className="contentAdmin bg-adminbg rounded p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="bg-white my-5 rounded-md ">
        <div className="flex justify-between ">
          <p className="text-xl text-black font-semibold px-3 py-7">
            Employer Subscriber List
          </p>
        </div>
        <TableContainer>
          <Table size="sm">
            <Thead className="bg-gray-200">
              <Tr className="w-full">
                <Th>ID</Th>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th>Order no.</Th>
                <Th>Payment Status</Th>
                <Th>Subscription Type</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {subscribers && subscribers.length > 0 ? (
                subscribers.map((subscriber, index) => (
                  <Tr key={subscriber?.uuid}>
                    <Td>{index + 1}</Td>
                    <Td>{subscriber?.employer?.name}</Td>
                    <Td textColor={"green"}>{subscriber?.employer?.email}</Td>
                    <Td>
                      <div className="text-sm opacity-90 text-blue-700">
                        {subscriber?.employer?.phone}
                      </div>
                    </Td>
                    <Td textColor={"gray"}>{subscriber?.order_id || "N/A"}</Td>
                    <Td textColor={"gray"}>
                      {subscriber?.payment_status || "N/A"}
                    </Td>
                    <Td textColor={"green"} className="">
                      {subscriber?.status}
                    </Td>
                    <Td>
                      <Tooltip label="View Details" hasArrow placement="top">
                        <IconButton
                          aria-label="View details"
                          icon={<ViewIcon />}
                          onClick={() => handleViewDetails(subscriber)}
                          colorScheme="blue"
                          size="sm"
                          variant="outline"
                        />
                      </Tooltip>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="8" className="text-center py-4 text-gray-500">
                    No data available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={4}
        px={4}
        py={2}
      >
        <Text>
          Page {pagination?.current_page} of {pagination?.last_page}
        </Text>
        <Flex>
          <Button
            onClick={() => handlePageChange(pagination?.current_page - 1)}
            isDisabled={pagination?.current_page === 1}
            mr={2}
          >
            Previous
          </Button>
          <Button
            onClick={() => handlePageChange(pagination?.current_page + 1)}
            isDisabled={pagination?.current_page === pagination?.last_page}
          >
            Next
          </Button>
        </Flex>
      </Flex>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
        <ModalOverlay />
        <ModalContent maxH="90vh">
          <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
            Subscriber Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflowY="auto">
            {selectedSubscriber && (
              <VStack align="stretch" spacing={4}>
                {Object.entries(selectedSubscriber).map(([key, value]) =>
                  typeof value !== "object" ? (
                    <HStack key={key} justifyContent="space-between">
                      <Text fontWeight="bold">{key.replace(/_/g, " ")}:</Text>
                      <Text>
                        {key === "created_at" && value
                          ? formatDate(value)
                          : value === 0
                          ? "No"
                          : value === 1
                          ? "Yes"
                          : value || "N/A"}
                      </Text>
                    </HStack>
                  ) : null
                )}
                {/* Handling nested employer object */}
                {selectedSubscriber?.employer &&
                  Object.entries(selectedSubscriber.employer).map(
                    ([key, value]) => (
                      <HStack key={key} justifyContent="space-between">
                        <Text fontWeight="bold">
                          Employer {key.replace(/_/g, " ")}:
                        </Text>
                        <Text>
                          {key === "created_at" && value
                            ? formatDate(value)
                            : value === 0
                            ? "No"
                            : value === 1
                            ? "Yes"
                            : value || "N/A"}
                        </Text>
                      </HStack>
                    )
                  )}
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default SubscriberList;
